<template>
  <div class="content">
    <div class="header">
      <el-button @click="pageChange(1)">查询</el-button>
      <el-button @click="setComponents('VirtuallyEditor')">新增</el-button>
    </div>
    <div class="header-where">
      <el-descriptions size="mini" direction="vertical" :column="1" border>
        <el-descriptions-item label="查询条件">
          <el-descriptions size="mini" :column="2" border>
            <el-descriptions-item label="房产范围">
              {{where.house_name}}
            </el-descriptions-item>
            <el-descriptions-item label="房号">
              <el-input size="mini" style="width: 180px;" v-model="where.HouseNumber" clearable></el-input>
            </el-descriptions-item>
          </el-descriptions>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="body">
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          v-if="pageData" :data="pageData.list"
          border
          style="width: 100%">
          <el-table-column
            prop="id"
            label="ID" width="90">
          </el-table-column>
          <el-table-column
            prop="dummy_meter_id"
            label="编号" width="120">
            <template slot-scope="scope">
              <el-link type="primary" @click="setComponents('VirtuallyEditor',scope.row.id)">{{scope.row.dummy_meter_id}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="dummy_meter_name"
            label="名称" width="180">
          </el-table-column>
          <el-table-column
            prop="meter_kind_name"
            label="仪表性质" width="100">
          </el-table-column>

          <el-table-column
            prop="HouseName"
            label="房产" width="320">
          </el-table-column>
          <el-table-column
            prop="is_using_name"
            label="使用状态" width="100">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

import {CommonHelp} from "../../../Butler/common/CommonHelp";

export default {
  name: "VirtuallyList",
  components:{},
  inject:["mainObj","setComponentId"],
  data(){
    return{
      where:{
        house_id:"",
        HouseNumber:"",
      },
      loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
    }
  },
  activated() {
    const that=this;
    that.where.house_id=that.house_id;
    that.where.house_name=that.house_name;

    CommonHelp.debounce(()=>{
      that.pageChange(1)
    },500,that)

  },
  watch: {
    house_id(n,o){
      this.where.house_id=n;
    },
    house_name(n,o){
      this.where.house_name=n;
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
      },500,that)
    },
    project_id(n,o){
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
      },500,that)
    }
  },
  computed:{
    house_id(){
      return (this.mainObj||{}).house_id||''
    },
    house_name(){
      return (this.mainObj||{}).house_name||''
    },
    project_id(){
      return (this.mainObj||{}).project_id||''
    }
  },
  methods:{
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that=this;
      let where={
        ...that.where,
        project_id:that.project_id,
        pageSize:that.pageData.pageSize,
        page:that.pageData.page,
      }
      that.project_id&&ERP.getRequest({url:"admin/MeterVirtually/getVirtuallyList",data:where},ret=>{
        if(ret.code){
          that.pageData=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    setComponents(componentsId,id=""){
      this.mainObj.id=id;
      this.setComponentId(componentsId)
    },
    goExcel(is_ceased=0){
      this.mainObj.excel_type=is_ceased;
      this.setComponentId("CustomerRentBatch")
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/MeterVirtually/components/virtually/VirtuallyList.vue